import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import '../App.css';
// import { Link } from 'react-router-dom';
// import { NavHashLink as Link} from 'react-router-hash-link'; 
import { BrowserRouter as Router} from 'react-router-dom';
import { Link } from 'react-scroll';

const useStyles = makeStyles(theme => ({
    barTransparent: {
        backgroundColor: "transparent",
        color: "var(--page-white)",
        boxShadow: "none",
        transition: "ease-in .2s"
    },
    barSolid: {
        backgroundColor: "var(--page-white)",
        color: 'var(--page-black)',
        transition: "ease-in-out .2s"
    }
}));



function ReactHeader() {
    // const useState = useState;
    const classes = useStyles();
    const [navBackground, setnavBackground] = useState('barTransparent')

    const navRef = React.useRef();
    navRef.current = navBackground;

    useEffect(() => {
        const handleScroll = () => {
            const show = window.scrollY > 220

            if(show) {
                setnavBackground('barSolid')
            } else if(!show) {
                setnavBackground('barTransparent')
            }
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll',  handleScroll)
        }
    }, [])

    return (
        <Router>
            <div className="reactHeader">
                <AppBar position='fixed' className={classes[navRef.current]}>
                    <Toolbar>
                        <div className="header">
                            <h1 className="webTitle">{"<AA/>"}</h1>

                            <ul className="nav">
                                <li className="nav-item">
                                    {/* <a>Home</a> */}
                                    <Link
                                        activeClass="active"
                                        spy={true}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                        to="home"
                                        activeClassName="selected"  
                                    >
                                        Home
                                    </Link>
                                </li>
            
                                    
                                <li className="nav-item">
                                    {/* <a>My Works</a> */}
                                    <Link
                                        activeClass="active"
                                        spy={true}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                        to="works"
                                        activeClassName="selected"        
                                    >
                                        My Works
                                    </Link>
                                </li>
                                    
                                <li className="nav-item">
                                    {/* <a>About Me</a> */}
                                    <Link
                                        activeClass="active"
                                        spy={true}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                        to="about"
                                        activeClassName="selected"        
                                    >
                                        About Me
                                    </Link>
                                </li>
                            </ul>
                        </div>

                    </Toolbar>
                </AppBar>

            </div>
        </Router> 
    );
    
}
 
export default ReactHeader;